import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Editor } from '../models/editor.model';
import { Editorcontrolitem } from '../models/editorcontrolitem.model';
import { DynamicFormLayoutModel } from '../models/dynamicformlayout.model';
import { DynamicFieldsManagerService } from '../service/dynamic-fields-manager.service';
import { JsonPipe } from '@angular/common';
import { DataService } from '../service/data.service';


@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.less']
})
export class SettingComponent extends BaseComponent implements OnInit {

  tmpDicKey: string = "";
  tmpDicValue: string = "";
  prop:string="DynamicFormLayoutModel.HttpAlias";
  currentJsonImport:string=""

  constructor(dataService: DataService, public settingsDialog: MatDialog, private binder:DynamicFieldsManagerService) {
    super(dataService);

    var controls:Editorcontrolitem[] = [];
    controls.push(new Editorcontrolitem(1, "clientid", "type", "ct", "property123", "v", null, "{}"));
  }

  ngOnInit() {

  }

  getArrayRef(arrayObj){

    if(typeof(arrayObj)!="undefined" && arrayObj!=null){
      if(arrayObj.$type!=null){
        return arrayObj.$values;
      }else{
        return arrayObj;
      }
    }

    return null;
  }

  checkProp(prop) {
    return this.data.selectedItemTmp.Settings[prop] != null;
  }

  resolve(obj, path) {
    return path.split('.').reduce(function (prev, curr) {
      return prev ? prev[curr] : null
    }, obj || self)
  }


  add(prop) {

    if (this.data.selectedItemTmp.Settings[prop] == null) {
       this.data.selectedItemTmp.Settings[prop] = [];
    }

    var array = this.getArrayRef(this.data.selectedItemTmp.Settings[prop]);
    array.push("");    
  }

  trackByFn(index: any, item: any) {
    return index;
  }


  removeString(prop, i) {
    this.getArrayRef(this.data.selectedItemTmp.Settings[prop]).splice(i, 1);
  }

  removeFromDictionary(prop, i) {
    delete this.data.selectedItemTmp.Settings[prop][i];
  }

  addNewDictionary(prop) {
    if (this.data.selectedItemTmp.Settings[prop] == null) {
      this.data.selectedItemTmp.Settings[prop] = {};
    }

    if (this.tmpDicKey != null && this.tmpDicKey != '' && this.tmpDicValue != null && this.tmpDicValue != '') {

      this.data.selectedItemTmp.Settings[prop][this.tmpDicKey] = this.tmpDicValue;

      this.tmpDicKey = "";
      this.tmpDicValue = "";
    }
  }

  addNewComplex(prop){
    if (this.getArrayRef(this.data.selectedItemTmp.Settings[prop]) == null || Array.isArray(this.getArrayRef(this.data.selectedItemTmp.Settings[prop])) == false) {
      this.data.selectedItemTmp.Settings[prop] = [];
    }
    this.getArrayRef(this.data.selectedItemTmp.Settings[prop]).push({});
  }
  removeFromComplex(prop, i){
    this.getArrayRef(this.data.selectedItemTmp.Settings[prop]).splice(i, 1);
  }

  closeSettingsDialog(){
    this.settingsDialog.closeAll();
  }

  okSettingsDialog(){
    this.data.confirmTmpItem();
    this.settingsDialog.closeAll();
  }

  showCurrentSettinsJson(){
    return JSON.stringify(this.data.selectedItemTmp.Settings);
  }

  applySettingsJson(){
    this.data.validateSettings(this.data.selectedItemTmp.Type,this.currentJsonImport).subscribe(
      (data)=> {
        this.data.selectedItemTmp.Settings = JSON.parse(this.currentJsonImport);
        this.currentJsonImport  = "";
      alert("Settings imported successfully!");
    },
    
    (err)=> {
      alert("Error importing settings. Please check type of the settings object.");
    });
    
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent){
    //alert(tabChangeEvent.index);
  }

}


